import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'
import { CARGO_ANALISE_DE_UX_EXPERIENCIA_DO_USUARIO } from '@/components/Configuracao/mapaCargos/data/cargo-analise-de-ux-experiencia-do-usuario'
import { CARGO_DESIGNER } from '@/components/Configuracao/mapaCargos/data/cargo-designer'
import { CARGO_REDATOR } from '@/components/Configuracao/mapaCargos/data/cargo-redator'
import { CARGO_ANALISTA_DE_COMUNICACAO_E_ENDOMARKETING } from '@/components/Configuracao/mapaCargos/data/cargo-analista-de-comunicacao-e-endomarketing'
import { CARGO_ANALISTA_DE_MARKETING_PLANEJAMENTO } from '@/components/Configuracao/mapaCargos/data/cargo-analista-de-marketing-planejamento'
import { CARGO_ANALISTA_DE_MARKETING_OPERACOES } from '@/components/Configuracao/mapaCargos/data/cargo-analista-de-marketing-operacoes'
import { CARGO_ANALISTA_DE_SUPORTE } from '@/components/Configuracao/mapaCargos/data/cargo-analista-de-suporte'
import { CARGO_ANALISTA_DE_MIDIA_PAGA } from '@/components/Configuracao/mapaCargos/data/cargo-analista-de-midia-paga'
import { CARGO_ANALISTA_DE_SEO } from '@/components/Configuracao/mapaCargos/data/cargo-analista-de-seo'
import { CARGO_ANALISTA_DE_TRAFEGO_PAGO } from '@/components/Configuracao/mapaCargos/data/cargo-analista-de-trafego-pago'
import { CARGO_GESTOR_DE_TRAFEGO } from '@/components/Configuracao/mapaCargos/data/cargo-gestor-de-trafego'
import { CARGO_ANALISTA_DE_PROJETOS } from '@/components/Configuracao/mapaCargos/data/cargo-analista-de-projetos'
import { CARGO_GERENTE_DE_PROJETOS } from '@/components/Configuracao/mapaCargos/data/cargo-gerente-de-projetos'
import { CARGO_HEAD_DE_RELACIONAMENTO_COM_CLIENTE } from '@/components/Configuracao/mapaCargos/data/cargo-head-de-relacionamento-com-cliente'
import { CARGO_DESENVOLVEDOR_FRONTEND } from '@/components/Configuracao/mapaCargos/data/cargo-desenvolvedor-frontend'

export const MAPA_CARGOS: MapaCargo[] = [
  CARGO_ANALISE_DE_UX_EXPERIENCIA_DO_USUARIO,
  CARGO_DESIGNER,
  CARGO_REDATOR,
  CARGO_ANALISTA_DE_COMUNICACAO_E_ENDOMARKETING,
  CARGO_ANALISTA_DE_MARKETING_PLANEJAMENTO,
  CARGO_ANALISTA_DE_MARKETING_OPERACOES,
  CARGO_ANALISTA_DE_SUPORTE,
  CARGO_ANALISTA_DE_MIDIA_PAGA,
  CARGO_ANALISTA_DE_SEO,
  CARGO_ANALISTA_DE_TRAFEGO_PAGO,
  CARGO_GESTOR_DE_TRAFEGO,
  CARGO_ANALISTA_DE_PROJETOS,
  CARGO_GERENTE_DE_PROJETOS,
  CARGO_HEAD_DE_RELACIONAMENTO_COM_CLIENTE,
  CARGO_DESENVOLVEDOR_FRONTEND,
]
